import classnames from 'classnames';
import { downcastRef } from '../../util/typing';
import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
/**
 * Render a labeled checkbox or radio input. The input is styled with two icons:
 * one for the unchecked state and one for the checked state. The input itself
 * is positioned exactly on top of the icon, but is non-visible.
 */
export default function ToggleInput({
  children,
  elementRef,
  containerRef,
  checked,
  icon: UncheckedIcon,
  checkedIcon: CheckedIcon,
  disabled,
  onChange,
  id,
  type,
  containerClasses,
  ...htmlAttributes
}) {
  const Icon = checked ? CheckedIcon : UncheckedIcon;
  return _jsxs("label", {
    className: classnames('relative flex items-center gap-x-1.5', {
      'cursor-pointer': !disabled,
      'opacity-70': disabled
    }, containerClasses),
    htmlFor: id,
    "data-composite-component": type === 'checkbox' ? 'Checkbox' : 'RadioButton',
    ref: downcastRef(containerRef),
    children: [_jsx("input", {
      ...htmlAttributes,
      type: type,
      ref: downcastRef(elementRef),
      className: classnames(
      // Set the special Tailwind peer class to allow sibling elements
      // to style themselves based on the state of this element
      'peer',
      // Position this atop the icon and size it to the same dimensions
      'absolute w-em h-em',
      // Make input visually hidden, but some screen readers won't read out
      // elements with 0 opacity
      'opacity-[.00001]', {
        'cursor-pointer': !disabled
      }),
      checked: checked,
      disabled: disabled,
      id: id,
      onChange: onChange
    }), _jsx(Icon, {
      className: classnames(
      // Add an outline ring to the icon when the input is focus-visible.
      // The ring needs to be applied here because the `input` has an
      // effectively-0 opacity.
      'peer-focus-visible:ring',
      // Set preferred size of icon to match text.
      'w-em h-em',
      // Set minimum size of icon to minimum size of SVG.
      'min-w-min min-h-min')
    }), _jsx("span", {
      children: children
    })]
  });
}
//# sourceMappingURL=ToggleInput.js.map